document.addEventListener("DOMContentLoaded", function () {

  const imagesContainer = document.querySelector(".isYogdoLEbGsDx8yc");
  const images = imagesContainer.querySelectorAll('[data-instant-type="media"]');

  const wrapper = document.querySelector(".iTLKjsJljlErXPFvy");
  const stepsContainer = document.querySelector(".ir315btvJojVSASoI");
  const progressBar = document.querySelector(".iSJvpo4fl5jvJExKJ");

  if (!wrapper || !stepsContainer || !progressBar) return

  const steps = stepsContainer.children;

  let stepPositions = [];
  let startOffset = 0;

  function calculate() {
    const scrollY = window.scrollY || window.pageYOffset;

    stepPositions = [];

    startOffset =
      scrollY +
      stepsContainer.getBoundingClientRect().top -
      window.innerHeight / 2;

    Array.from(steps).forEach((step) => {
      stepPositions.push(
        scrollY +
          step.getBoundingClientRect().top -
          window.innerHeight / 2
      );
    });
  }

  function findActive(scroll) {
    let index = 0;

    for (let i = 0; i < stepPositions.length; i++) {
      if (stepPositions[i] < scroll) {
        index = i;
      }
    }

    return index;
  }

  function mapRange(value, inMin, inMax, outMin, outMax) {
    return Math.max(
      outMin,
      Math.min(
        outMax,
        ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
      )
    );
  }

  function update() {
    const scroll = window.scrollY || window.pageYOffset;

    const active = findActive(scroll);

    Array.from(steps).forEach((step, index) => {
      const indicator = step.querySelector('[data-instant-type="media"] img');
      const textWrap = step.querySelector('[data-instant-type="text"]')?.parentElement;

      if (indicator) {
        indicator.style.opacity = index <= active ? "1" : "0.5";
      }

      if (textWrap) {
        textWrap.style.opacity = index <= active ? "1" : "0.5";
      }
    });


    images.forEach((img, index) => {
    if (index === active) {
      img.style.opacity = "1";
    } else {
      img.style.opacity = "0";
    }
    });

    const height = stepsContainer.getBoundingClientRect().height;

    const progress = mapRange(
      scroll - startOffset,
      0,
      height,
      0,
      100
    );

    progressBar.style.height = progress + "%";
  }

  calculate();
  update();

  window.addEventListener("scroll", update);
  window.addEventListener("resize", () => {
    calculate();
    update();
  });
});
